/**
 * Centralized Google Analytics 4 event tracking utility.
 * GA is loaded globally via gtag.js in public/index.html.
 */

declare function gtag(...args: unknown[]): void;

export const trackEvent = (
  eventName: string,
  params?: Record<string, unknown>
): void => {
  if (typeof gtag === "function") {
    gtag("event", eventName, params ?? {});
  }
};

// ─── Event Name Constants ────────────────────────────────────────────────────

export const GA_EVENTS = {
  // Navigation
  PAGE_VIEW_HOME: "page_view_home",
  PAGE_VIEW_APP: "page_view_app",
  CLICK_START_DESIGNING: "click_start_designing",

  // Canvas
  BLOCK_ADDED: "block_added",
  BLOCK_DELETED: "block_deleted",
  CONNECTION_ADDED: "connection_added",
  CONNECTION_DELETED: "connection_deleted",

  // Game controls
  GAME_STARTED: "game_started",
  GAME_PAUSED: "game_paused",
  GAME_RESUMED: "game_resumed",

  // IOPS Config Modal
  IOPS_MODAL_OPENED: "iops_modal_opened",
  IOPS_CONFIG_SAVED: "iops_config_saved",
  TRAFFIC_PATTERN_CHANGED: "traffic_pattern_changed",

  // Scoreboard actions
  DESIGN_SAVED: "design_saved",
  DESIGN_RESTORED: "design_restored",
  DESIGN_DELETED: "design_deleted",
  CANVAS_RESET: "canvas_reset",

  // IOPS modal route and content actions
  CONTENT_TYPE_ADDED: "content_type_added",
  CONTENT_TYPE_REMOVED: "content_type_removed",
  ROUTE_ADDED: "route_added",
  ROUTE_REMOVED: "route_removed",
  ROUTE_PATH_RENAMED: "route_path_renamed",

  // Interview problem library
  PAGE_VIEW_PROBLEMS: "page_view_problems",
  PROBLEM_LIBRARY_OPENED: "problem_library_opened",
  PROBLEM_STARTED: "problem_started",
  PROBLEM_RESUMED: "problem_resumed",
  PROBLEM_RESTARTED: "problem_restarted",

  // Accounts
  AUTH_GATE_SHOWN: "auth_gate_shown",
  SIGN_UP_STARTED: "sign_up_started",
  SIGN_UP_COMPLETED: "sign_up_completed",
  SIGN_IN: "sign_in",
  SIGN_OUT: "sign_out",
  PROBLEM_LEFT: "problem_left",
  PROBLEM_HINT_REVEALED: "problem_hint_revealed",
} as const;
